<app-main-sidebar></app-main-sidebar>
<div #container id="mainContainer">
  <div class="main-content">
    <router-outlet></router-outlet>
    <app-site-footer></app-site-footer>
  </div>
</div>
